export const STATE_NAME = 'paymentMethods';
